

import { Box, Checkbox, FormControlLabel } from '@mui/material';
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import BaseCard from '../../../components/Cards/Card';
import CustomEmailInput from '../../../components/EmailInput';
import CustomPasswordInput from "../../../components/PasswordInput";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormik } from 'formik';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { BASE_URL, URL } from "../../../components/BaseUrl";
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../../Redux/Slices/AuthSlice';
import InvalidOtpModal from './InvalidOtpModal';
import { getApiMessage } from '../../../utils/messageHandler';
import ProfileIncompleteModal from "./profileIncompleteModal"
import InviteSetupModal from "./InviteSetupModal";
import AccountSetupRequiredModal from "./AccountSetupRequiredModal";

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate()
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [pendingEmail, setPendingEmail] = useState("");
  const [pendingMessage, setPendingMessage] = useState("");
  const [inviteSetup, setInviteSetup] = useState(null);
  const [showSetupRequiredModal, setShowSetupRequiredModal] = useState(false);
  useEffect(() => {
    const saved = localStorage.getItem("workerCredentials");
    if (saved) {
      const { email, password } = JSON.parse(saved);
      formik.setFieldValue("email", email);
      formik.setFieldValue("password", password);
      setRememberMe(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validate = (values) => {
    const errors = {};

    // Email validation
    if (!values.email) {
      errors.email = t('login.emailRequired');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      errors.email = t('login.emailInvalid');
    }

    // Password validation
    if (!values.password) {
      errors.password = t('login.passwordRequired');
    } else if (values.password.length < 8) {
      errors.password = t('login.passwordTooShort');
    } else if (
      !/(?=.*[a-z])/.test(values.password) ||
      !/(?=.*[A-Z])/.test(values.password) ||
      !/(?=.*[!@#$%^&*])/.test(values.password)
    ) {
      errors.password = t('login.passwordInvalid');
    }

    return errors; // 🔴 This and closing bracket were missing
  };
const [showProfileIncompleteModal, setShowProfileIncompleteModal] = useState(false);

  const formik = useFormik({
    initialValues: { email: '', password: '' },
    validate,
    onSubmit: async (values) => {
      const errors = validate(values);
      if (Object.keys(errors).length > 0) {
        // Show first error
        if (errors.email) toast.error(errors.email);
        else if (errors.password) toast.error(errors.password);
        return;
      }

      setLoading(true); // Start loader
      try {
        const response = await fetch(`${BASE_URL}/public/worker/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
        });

        const data = await response.json();
        console.log("📥 Full login response:", data);
        const loginData = data?.data || data;
        const loginStatus = loginData?.status;

      

        // only log worker details if they exist
        if (data?.data?.worker) {
          console.log("User after login:", data.data.worker);
          console.log("Original token:", data.data.token);
        }

        if (loginStatus === "email_verification_required") {
          setPendingEmail(loginData?.email || values.email);
          setPendingMessage(loginData?.message || data?.message);
          setShowVerifyModal(true);
          setLoading(false);
          return; // stop flow here
        }

        if (loginStatus === "setup_required") {
          setShowSetupRequiredModal(true);
          setLoading(false);
          return; // stop flow here
        }

        if (loginStatus === "pending_approval") {
          navigate("/admin-approval", {
            state: { message: loginData?.message || data?.message },
          });
          return; // stop further execution
        }

        if (loginStatus === "invite_setup_required") {
          const inviteData = loginData;
          if (inviteData.password_token) {
            localStorage.setItem("workerPasswordToken", inviteData.password_token);
          }
          if (inviteData.worker_id) {
            localStorage.setItem("currentWorkerId", String(inviteData.worker_id));
            localStorage.setItem("workerId", String(inviteData.worker_id));
          }
          localStorage.setItem("inviteEmail", inviteData.email || values.email);
          setInviteSetup({
            type: "profile",
            email: inviteData.email || values.email,
            workerId: inviteData.worker_id,
          });
          return;
        }

        if (loginStatus === "password_required") {
          const passwordData = loginData;
          if (passwordData.password_token) {
            localStorage.setItem("workerPasswordToken", passwordData.password_token);
          }
          if (passwordData.worker_id) {
            localStorage.setItem("currentWorkerId", String(passwordData.worker_id));
            localStorage.setItem("workerId", String(passwordData.worker_id));
          }
          localStorage.setItem("inviteEmail", passwordData.email || values.email);
          setInviteSetup({
            type: "password",
            email: passwordData.email || values.email,
          });
          return;
        }
        
if (data.message === "Profile incomplete" || data.error === true && data.status === "profile_incomplete") {
  
  // SHOW LANGUAGE BASED TOAST
  // const langMessage = t("language") === "es"
  //     ? data.message_es || "Perfil incompleto"
  //     : data.message_en || "Profile incomplete";

  // toast.error(langMessage);

  // OPEN THE MODAL
  setShowProfileIncompleteModal(true);

  return; // stop login flow
}

          if (!response.ok || data.error) {
          // Show backend message in appropriate language
          toast.error(getApiMessage(data, "Invalid credentials"));
          setLoading(false);
          return;
        }

        if (!response.ok || data.error) {
          throw new Error(data.message || "Login failed");
        }

        if (rememberMe) {
          localStorage.setItem("workerCredentials", JSON.stringify(values));
        } else {
          localStorage.removeItem("workerCredentials");
        }
        dispatch(setCredentials({ token: data.data.token, user: data.data.worker }));

        // toast.success(t("login.loginSuccess"));

        setTimeout(() => {
          navigate("/dashboard");
        }, 1500);
      } catch (error) {
        console.error("🚨 Login error caught:", error);       // <-- log the error object
        console.error("🔍 Error message:", error.message);    // <-- log the message string
        // If error has response data, use getApiMessage, otherwise use error.message
        const errorMsg = error.response?.data ? getApiMessage(error.response.data, t("login.loginFailed")) : (error.message || t("login.loginFailed"));
        toast.error(errorMsg);

      } finally {
        setLoading(false); // Stop loader
      }
    }


  });



  const handleForget = () => {
    navigate("/forget-password")
  }
  return (
    <Box sx={{ backgroundColor: "#EFF4F8", mt: isMobile ? 6 : 0, pt: 0, py: 5, }}>

      <Box sx={{
        px: 2, display: 'flex', justifyContent: 'center',
        minHeight: "100vh",
        alignItems: "center",
      }}>
        <BaseCard
          maxWidth={isMobile ? '100%' : 380}
          sx={{
            width: isMobile ? '100%' : 'auto',
            boxSizing: 'border-box',
            px: isMobile ? 2 : 0,
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8, mb: 2 }}>
                <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main, letterSpacing: "0px !important" }}>
                  {t('login.title')}
                </CustomText>
                <CustomText sx={{ ...textStyles.body4, color: theme.palette.text.primary, letterSpacing: "0px !important" }}>
                  {t('login.subtitle')}
                </CustomText>
              </Box>

              <label className='email_label'>{t('login.emailLabel')}</label>
              <CustomEmailInput
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && formik.errors.email}
              />
              {formik.touched.email && formik.errors.email && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formik.errors.email}</span>
              )}

              <label>{t('login.passwordLabel')}</label>
              <CustomPasswordInput
                placeholder="********"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.password && formik.errors.password}
              />
              {formik.touched.password && formik.errors.password && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formik.errors.password}</span>
              )}

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      size="small"
                      sx={{ p: 0, mr: 1 }}
                    />
                  }
                  label={
                    <CustomText sx={{ ...textStyles.body4, fontWeight: 400, color: theme.palette.text.primary }}>
                      {t("login.rememberMe")}
                    </CustomText>
                  }
                />
                <CustomText
                  sx={{ ...textStyles.body4, fontWeight: 400, color: theme.palette.primary.main, cursor: "pointer" }}
                  onClick={handleForget}
                >
                  {t("login.forgotPassword")}
                </CustomText>
              </Box>
              {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <CustomText sx={{ ...textStyles.body4,fontWeight:400, color: theme.palette.primary.main ,cursor:"pointer",letterSpacing:"0px !important"}} onClick={handleForget}>
               {t('login.forgotPassword')}
                </CustomText>
              </Box> */}

              <CustomButton
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    {loading && (
                      <CircularProgress
                        size={18}
                        sx={{ color: '#fff', mr: 1 }}
                      />
                    )}
                    {t('login.loginButton')}
                  </Box>
                }
                type="submit"
                fullWidth
                sx={{ mt: 2 }}
              />
            </Box>
          </form>
        </BaseCard>
      </Box>
      <InvalidOtpModal
        open={showVerifyModal}
        onClose={() => setShowVerifyModal(false)}
        email={pendingEmail}
        message={pendingMessage}
      />
      <AccountSetupRequiredModal
        open={showSetupRequiredModal}
        onClose={() => setShowSetupRequiredModal(false)}
      />
      <ProfileIncompleteModal
  open={showProfileIncompleteModal}
  onClose={() => setShowProfileIncompleteModal(false)}
  onContinue={() => {
    setShowProfileIncompleteModal(false);
    navigate("/create-profile"); // OR face enrollment page
  }}
/>
      <InviteSetupModal
        open={Boolean(inviteSetup)}
        onClose={() => setInviteSetup(null)}
        type={inviteSetup?.type}
        onContinue={() => {
          if (!inviteSetup) return;
          const nextPath = inviteSetup.type === "password"
            ? "/set-password"
            : "/update-invite-profile";
          setInviteSetup(null);
          navigate(nextPath, {
            state: {
              email: inviteSetup.email,
              workerId: inviteSetup.workerId,
            },
            replace: true,
          });
        }}
      />
    </Box>
  );
};

export default Login;








